import { gql } from '@apollo/client';

export default gql`
  mutation UpdateBlindLabelPanelProductId(
    $input: UpdatePanelProductByIdInput!
  ) {
    updatePanelProductById(input: $input) {
      panelProduct {
        id
        blindLabel
      }
    }
  }
`;
